import { fontSize } from "@/util/common/fontSize";
import echarts from "echarts";

let px16 = fontSize(16);
export const getOption = function (list) {
  let xAxisData = [];
  let valueList = [];
  let countList = [];
  if (list.length) {
    for (let i = 0; i < list.length; i++) {
      let item = list[i];
      let wasteName = item.wasteName;
      // if(wasteName.length > 3) {
      //     wasteName = wasteName.substring(0,2) + ".."
      // }
      xAxisData.push(wasteName);
      countList.push(item.count);
      valueList.push(item.totalWeight || Math.random());
    }
  }
  return {
    grid: {
      top: fontSize(10),
      bottom: 100,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        crossStyle: {
          color: "#999",
        },
      },
      formatter: function (params) {
        //console.log(params)
        let res =
          params[0].name +
          "<br/>共:" +
          countList[params[0].dataIndex] +
          "件" +
          "<br/>合计:" +
          params[0].value +
          "吨";
        return res;
      },
    },
    xAxis: [
      {
        type: "category",
        data: xAxisData,
        axisLine: {
          lineStyle: {
            color: "rgba(255,255,255,0.12)",
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: "#fff",
          fontSize: fontSize(10),
          // align: "center",
          // rotate: 45,
          formatter: function (value, index) {
            // return value.substring(0,2);
            return value.replace(/(.{5})/g, '$1\n');
            return value;
          },
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        axisLine: {
          show: false,
        },
        axisLabel: {
          color: "#929292",
          fontSize: fontSize(10),
        },
        splitLine: {
          lineStyle: {
            color: "#0B5B85",
            type: "dotted",
          },
        },
      },
    ],
    series: [
      {
        type: "bar",
        barWidth: fontSize(16),
        data: valueList,
        showBackground: true,
        itemStyle: {
          color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
            { offset: 0, color: "#3FC1FF" },
            { offset: 0.5, color: "#3FC1FF" },
            { offset: 1, color: "rgba(63,193,255,0.26)" },
          ]),
        //   barBorderRadius: [px16, px16, px16, px16],
        },
        // emphasis: {
        //   disabled: false,
        //   itemStyle: {
        //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //       { offset: 0, color: "#3FC1FF" },
        //       { offset: 0.5, color: "#3FC1FF" },
        //       { offset: 1, color: "rgba(63,193,255,0.26)" },
        //     ]),
        //     shadowColor: "rgba(10,146,255,0.5)",
        //   },
        // },
      },
    ],
  };
};
